export default {"src":"/_next/static/media/AT.fa159e28.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};